/**
 * Kelas field form bersama.
 *
 * Sebelumnya ada 36 deklarasi `const inputClass = "…"` hasil salin-tempel di 35
 * berkas, runtuh jadi 17 string berbeda. Tiga di antaranya menutupi 19 deklarasi
 * dan diangkat ke sini apa adanya — **string-nya identik**, jadi pemindahan ini
 * nol perubahan piksel. Sisanya memang bespoke dan dibiarkan lokal.
 *
 * Catatan warna (terukur 2026-07-28): `focus:border-primary` dan
 * `focus:border-[var(--brand-primary)]` SAMA-SAMA ikut merek tenant —
 * `--primary` di-inject sebagai triplet HSL dari warna merek yang sama
 * (`packages/shared/src/tenant-branding.ts`). Selisih terukurnya cuma
 * rgb(15,112,88) vs rgb(15,110,86), murni pembulatan hex→HSL. Jadi keduanya
 * boleh disatukan kapan pun tanpa merusak multi-tenancy.
 *
 * Yang BELUM diseragamkan (butuh keputusan desain, mengubah tampilan):
 * tinggi field (`py-2.5`/`py-2`/`py-3` vs `.control-h` yang punya lantai sentuh
 * 44px), radius (`rounded-lg` vs `rounded-xl`), perlakuan focus ring, dan
 * apakah dark mode didukung.
 */

/** Varian terbanyak (11 deklarasi): rounded-lg, latar putih, ring primary/20. */
export const inputClass =
  "w-full px-3.5 py-2.5 text-sm rounded-lg border border-[rgba(12,12,10,0.12)] bg-white text-warm-black outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-colors";

/** Varian rounded-xl tanpa latar, ring primary-light (5 deklarasi). */
export const inputClassXl =
  "w-full px-3.5 py-2.5 text-sm rounded-xl border border-[rgba(12,12,10,0.12)] text-warm-black outline-none focus:border-primary focus:ring-2 focus:ring-primary-light transition-colors";

/** Varian padat untuk baris tabel/modal kecil (3 deklarasi). */
export const inputClassCompact =
  "w-full px-3 py-2 text-sm rounded-lg border border-[rgba(12,12,10,0.12)] bg-white outline-none focus:border-primary";

/**
 * Varian sisi siswa (register, reset-password, community, account): rounded-xl,
 * border tipis, ring 10% (bukan 20% seperti varian admin), dark-mode-aware.
 * Sebelumnya 4 deklarasi bespoke nyaris identik — beda hanya padding/bg/transisi
 * yang tak fungsional, jadi disatukan tanpa kehilangan kebutuhan visual nyata.
 */
export const inputClassUser =
  "w-full px-3.5 py-2.5 text-sm rounded-xl border border-black/[0.08] dark:border-white/[0.08] text-[#0D0D0D] dark:text-white placeholder:text-[#9CA3AF] dark:placeholder:text-slate-500 outline-none focus:bg-white/80 dark:focus:bg-white/5 focus:border-[var(--brand-primary)]/40 dark:focus:border-[var(--brand-primary-bright)]/40 focus:ring-2 focus:ring-[var(--brand-primary)]/10 dark:focus:ring-[var(--brand-primary-bright)]/10 transition-all duration-150";

/** Field non-interaktif (data akun sudah login, ditampilkan bukan diedit). */
export const inputClassReadOnly =
  "w-full px-3.5 py-2.5 text-sm rounded-lg border border-[rgba(12,12,10,0.08)] bg-[rgba(12,12,10,0.03)] text-warm-black cursor-default select-none";
